import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../utils/api';
import * as ActionTypes from '../redux/action/types';
import { prepareKycDocumentFormData, withLoadingIndicator } from './utils';

function* fetchKycStatus() {
  try {
    const response = yield call(() => Api.getKycStatus());
    yield put({
      type: ActionTypes.FETCH_KYC_STATUS_SUCCESS,
      data: response.data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.FETCH_KYC_STATUS_FAILURE,
      data: {
        infoModal: {
          open: true,
          type: 'error',
          msg: e.message
        }
      }
    });
  }
}

function* uploadKycDocument({ data }) {
  const formData = prepareKycDocumentFormData(data);
  try {
    const response = yield call(() => Api.uploadKycDocument(formData));
    yield put({
      type: ActionTypes.UPLOAD_KYC_DOCUMENT_SUCCESS,
      data: response.data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.UPLOAD_KYC_DOCUMENT_FAILURE,
      data: {
        infoModal: {
          open: true,
          type: 'error',
          msg: e.message
        }
      }
    });
  }
}

function* deleteKycDocument({ id }) {
  try {
    const response = yield call(() => Api.deleteKycDocument(id));
    yield put({
      type: ActionTypes.DELETE_KYC_DOCUMENT_SUCCESS,
      data: response.data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.DELETE_KYC_DOCUMENT_FAILURE,
      data: {
        infoModal: {
          open: true,
          type: 'error',
          msg: e.message
        }
      }
    });
  }
}

function* cancelKycVerification() {
  try {
    yield call(() => Api.cancelKycVerification());
    yield put({
      type: ActionTypes.CANCEL_KYC_VERIFICATION_SUCCESS
    });
  } catch (e) {
    yield put({
      type: ActionTypes.CANCEL_KYC_VERIFICATION_FAILURE,
      data: {
        infoModal: {
          open: true,
          type: 'error',
          msg: e.message
        }
      }
    });
  }
}

function* kycSaga() {
  yield takeLatest(ActionTypes.FETCH_KYC_STATUS_REQUEST, fetchKycStatus);
  yield takeLatest(
    ActionTypes.UPLOAD_KYC_DOCUMENT_REQUEST,
    withLoadingIndicator(uploadKycDocument)
  );
  yield takeLatest(
    ActionTypes.DELETE_KYC_DOCUMENT_REQUEST,
    withLoadingIndicator(deleteKycDocument)
  );
  yield takeLatest(
    ActionTypes.CANCEL_KYC_VERIFICATION_REQUEST,
    withLoadingIndicator(cancelKycVerification)
  );
}

export default kycSaga;
